<!-- [FIX] Gunakan [formControl]="radioControl" (direct reference) menggantikan
     [formControlName]="ControlName" di dalam wrapper <form [formGroup]>.
     Pola lama menyebabkan double-registration scope_type di form group yang sama
     dan ControlName bisa null saat change detection dipicu oleh setValue() eksternal. -->
<ng-container [ngTemplateOutlet]="useLabel ? useLabelTpl : matRadioTpl"></ng-container>

<ng-template #useLabelTpl>
  <label class="form-label">{{ label }}</label>
  <div class="form-check p-0 mx-n3">
    <ng-container [ngTemplateOutlet]="matRadioTpl"></ng-container>
  </div>
</ng-template>

<ng-template #matRadioTpl>
  <fieldset [disabled]="disable" [class.disabled]="disable">
    <mat-radio-group
      [formControl]="radioControl"
      class="w-100 d-flex {{ rowClass }}"
      [ngClass]="{ 'gap-4': !rowClass, 'flex-column': useColumn }"
    >
      <ng-container *ngFor="let option of options; let first = first; let last = last">
        <mat-radio-button
          [disabled]="option.disabled"
          [value]="option.value"
          [ngClass]="{ 'col-12 gap-4': useColumn, col: !rowClass }"
        >
          <span [style.color]="option.disabled ? 'rgb(209, 209, 209)' : ''">{{
            option.display
          }}</span>
          <span
            *ngIf="option.labelExtra"
            [ngClass]="option.disabled ? 'option-disabled' : 'text-gray-700'"
            class="d-block mt-1 label-extra"
            >{{ option.labelExtra }}</span
          >
        </mat-radio-button>
      </ng-container>
    </mat-radio-group>
  </fieldset>
</ng-template>

<!-- [OLD - COMMENTED] Pola lama: wrapper form + [formControlName]="ControlName"
<form [formGroup]="form">
  <ng-container [ngTemplateOutlet]="useLabel ? useLabelTpl : matRadioTpl"></ng-container>

  <ng-template #useLabelTpl>
    <label class="form-label">{{ label }}:</label>
    <div class="form-check p-0 mx-n3">
      <ng-container [ngTemplateOutlet]="matRadioTpl"></ng-container>
    </div>
  </ng-template>

  <ng-template #matRadioTpl>
    <fieldset [disabled]="disable" [class.disabled]="disable">
      <mat-radio-group
        [formControlName]="ControlName"
        class="w-100 d-flex {{ rowClass }}"
        [ngClass]="{ 'gap-4': !rowClass, 'flex-column': useColumn }"
        ngDefaultControl
      >
        <ng-container *ngFor="let option of options; let first = first; let last = last">
          <mat-radio-button
            [disabled]="option.disabled"
            [value]="option.value"
            [class.radio-align-top]="!!option.labelExtra"
            [ngClass]="{ 'col-12 gap-4': useColumn, col: !rowClass }"
          >
            <span [ngClass]="option.disabled ? 'text-gray-700' : ''">{{ option.display }}</span>
            <span *ngIf="option.labelExtra" class="d-block mt-1 text-gray-700">{{
              option.labelExtra
            }}</span>
          </mat-radio-button>
        </ng-container>
      </mat-radio-group>
    </fieldset>
  </ng-template>
</form>
-->
